import { get, post, postExFile } from "@utils/httpUtil";

// 分页查询有奖推荐活动列表
export function awardRecommendActivityPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/page`, data, config);
}

// 生成有奖推荐活动ID（预分配ID，会生成一条状态为INIT的数据）
export function awardRecommendActivityGenerateId(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/generateId`, data, config);
}

// 新增或编辑有奖推荐活动
export function awardRecommendActivitySaveOrUpdate(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/saveOrUpdate`, data, config);
}

// 【医生】分页查询有奖推荐活动任务医生个性奖励（查询的是编辑过程中的数据）
export function taskSettingTempPageDoctorTaskSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/pageDoctorTaskSetting`, data, config);
}

// 【通用】根据ID设置有奖推荐活动任务个性奖励
export function taskSettingTempSetTaskSettingById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/setTaskSettingById`, data, config);
}

// 【医生】根据条件批量设置有奖推荐活动任务医生个性奖励
export function taskSettingTempSetDoctorTaskSettingByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/setDoctorTaskSettingByCondition`, data, config);
}

// 【基因检测产品】分页查询社区服务产品个性奖励列表（查询的是编辑过程中的数据）
export function taskSettingTempPageProductTaskSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/pageProductTaskSetting`, data, config);
}

// 【基因检测产品】根据条件批量设置有奖推荐活动任务基因检测产品个性奖励
export function taskSettingTempSetProductTaskSettingByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/setProductTaskSettingByCondition`, data, config);
}

// 查询指定列表里面没有设置个性奖励的数据
export function taskSettingTempFindNotExistTaskSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/findNotExistTaskSetting`, data, config);
}

// 【通用】根据操作序列号提交个性奖励设置记录
export function taskSettingTempCommit(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/commit`, data, config);
}

// 【通用】清空某个任务的个性奖励设置记录
export function taskSettingTempClear(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/clear`, data, config);
}

// 根据id发布有奖推荐活动
export function awardRecommendActivityPublishById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/publishById`, data, config);
}

// 根据id暂停有奖推荐活动
export function awardRecommendActivityPauseById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/pauseById`, data, config);
}

// 根据id开启有奖推荐活动
export function awardRecommendActivityOpenById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/openById`, data, config);
}

// 根据id结束有奖推荐活动
export function awardRecommendActivityCloseById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/closeById`, data, config);
}

// 根据id删除有奖推荐活动
export function awardRecommendActivityDeleteById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/deleteById`, data, config);
}

// 根据id查询有奖推荐活动详情
export function awardRecommendActivityFindById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/findById`, data, config);
}

// 根据id复制有奖推荐活动
export function awardRecommendActivityCopyById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/copyById`, data, config);
}

// 分页查询活动明细数据-推荐记录
export function awardRecommendActivityPageRecommendRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/pageRecommendRecord`, data, config);
}

// 分页查询活动明细数据-奖励明细
export function awardRecommendActivityPageAwardRecord(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/pageAwardRecord`, data, config);
}
// 根据条件批量设置有奖推荐活动任务活动个性奖励
export function setActivityTaskSettingByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/setActivityTaskSettingByCondition`, data, config);
}
// 分页查询有奖推荐活动任务活动个性奖励
export function pageActivityTaskSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/pageActivityTaskSetting`, data, config);
}
// 根据条件批量设置有奖推荐活动任务活动个性奖励
export function setProjectTaskSettingByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/setProjectTaskSettingByCondition`, data, config);
}
// 分页查询有奖推荐活动任务活动个性奖励
export function pageProjectTaskSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/pageProjectTaskSetting`, data, config);
}
// 根据条件批量设置有奖推荐活动任务内容个性奖励
export function setArticleTaskSettingByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/setArticleTaskSettingByCondition`, data, config);
}
// 分页查询有奖推荐活动任务内容个性奖励
export function pageArticleTaskSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/pageArticleTaskSetting`, data, config);
}
// 分页查询商品个性奖励
export function pageGoodsTaskSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  data.parentCatalogCode = 1000;
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/pageGoodsTaskSetting`, data, config);
}
// 批量设置商品个性奖励
export function setGoodsTaskSettingByCondition(data: Record<string | number, any>, config?: Record<string | number, any>) {
  data.parentCatalogCode = 1000;
  return post(`/c/pc/awardRecommendActivity/taskSetting/temp/setGoodsTaskSettingByCondition`, data, config);
}
